export default __webpack_public_path__ + "static/PANASAS_Incorrect-Use-H-9ccfb1be6388b7922116ffba19667137.jpg";